import React, { useState } from 'react'
import './BusinessFeatureTabs.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { faLocationArrow } from '@fortawesome/free-solid-svg-icons'
import { faAlignCenter } from '@fortawesome/free-solid-svg-icons'
import { faSearchPlus } from '@fortawesome/free-solid-svg-icons'
import { faAddressCard } from '@fortawesome/free-solid-svg-icons'
import { faShieldAlt } from '@fortawesome/free-solid-svg-icons'
import { faAndroid } from '@fortawesome/free-brands-svg-icons'
import { faApple } from '@fortawesome/free-brands-svg-icons'

const BusinessFeatureTabs = () => {
    const [tabIndex, setTabIndex] = useState(0);
    function toggleTabs(i){
        setTabIndex(i)
    }
    // === Tabs Data ===
    const tabsData = [
        {
            btnName: 'Location',
            btnIcon: faLocationArrow,
            contentTitle: 'Set Business Location',
            contentDescriptions: ['Elite Partyz makes it easier for your customers to find your business.  Local businesses, select your coverage area by setting the radius from your location.', 'If your business services certain states or all of Australia you can choose larger areas that your business covers by selecting states or all of Australia.'],
            featureList: ['Select the coverage area for your business', 'Local businesses large and small', 'National and online businesses'],
            phoneIMGPath: '/img/f-6.webp',
            appelBtnURL: 'https://apps.apple.com/us/app/elite-partyz-business/id1484040597?ls=1',
            andoBtnURL: 'https://play.google.com/store/apps/details?id=com.app.partyzsupplier'
        },
        {
            btnName: 'Secure Payments',
            btnIcon: faShieldAlt,
            contentTitle: "Send Payment Requests & Receive Secure Payments",
            contentDescriptions: ['Simple payments for your products and services.', 'With multiple payment options choose your accepted payment methods', 'Direct in app purchasing and payments from consumers easily'],
            featureList: ["Accept Credit & Debit Cards", "Accept PayID payments easily", "Accept EFT transactions directly"],
            phoneIMGPath: '/img/f-7.webp',
            appelBtnURL: 'https://apps.apple.com/us/app/elite-partyz-business/id1484040597?ls=1',
            andoBtnURL: 'https://play.google.com/store/apps/details?id=com.app.partyzsupplier'
        },
        {
            btnName: 'List Products & Services',
            btnIcon: faAlignCenter,
            contentTitle: 'List Multiple Products and Services',
            contentDescriptions: ["Elite Partyz is the premium platform to engage clients who are looking for your products, services and expertise for parties and events", "No matter what sort of business you have, if it is party or event related we have a category for you"],
            featureList: ["List items you sell", "List your hire & rental products", "List your services"],
            phoneIMGPath: '/img/f-8.webp',
            appelBtnURL: 'https://apps.apple.com/us/app/elite-partyz-business/id1484040597?ls=1',
            andoBtnURL: 'https://play.google.com/store/apps/details?id=com.app.partyzsupplier'
        },
        {
            btnName: 'Categories / Keywords',
            btnIcon: faSearchPlus,
            contentTitle: 'Choose Your Business Categories & Keywords',
            contentDescriptions: ["Elite Partyz app makes business simple and for clients to find you directly by choosing your business categories and keywords, our platform puts your business in front of consumers looking for your businesses products, services and expertise"],
            featureList: ["Category matching to event types showing your business", "Select keywords that best suit your business to be found", "Clients will see your business based on location, categories and keywords placing your business at their finger tips"],
            phoneIMGPath: '/img/f-9.webp',
            appelBtnURL: 'https://apps.apple.com/us/app/elite-partyz-business/id1484040597?ls=1',
            andoBtnURL: 'https://play.google.com/store/apps/details?id=com.app.partyzsupplier'
        },
        {
            btnName: 'Business Profile',
            btnIcon: faAddressCard,
            contentTitle: 'Manage Your Business Profile',
            contentDescriptions: ["Showcase your business on the Elite Partyz platform, all businesses can upload logo’s and business images to showcase your products, services and complete business services in one simple app.", "Clients can also checkout your website, Instagram & Facebook Pages"],
            featureList: ["Users can direct message you with enquiries within the app", "Users can click to call directly from your business profile", "Manage and customise your products and services easily"],
            phoneIMGPath: '/img/f-10.webp',
            appelBtnURL: 'https://apps.apple.com/us/app/elite-partyz-business/id1484040597?ls=1',
            andoBtnURL: 'https://play.google.com/store/apps/details?id=com.app.partyzsupplier'
        },
    ]
    // === Business Featurs tabs ===
    return (
        <div className="feature-tabs">
            <div className="container">
                <div className="feauter-tabs-main-content">
                    {/* === Tabs Button Group === */}
                    <div className="tabs-btn-group">
                        {/* === Button Loop === */
                            tabsData.map((button, btnNumber) => {
                                return(
                                    <div className={ tabIndex === btnNumber ? "tabs-btn active" : "tabs-btn"} key={`BUTTON${btnNumber}`} onClick={() => toggleTabs(btnNumber)}>
                                        <span className="btn-icon"><FontAwesomeIcon icon={button.btnIcon} /></span>
                                        <span className="btn-name">{button.btnName}</span>
                                        <div className="animation"></div>
                                    </div>
                                )
                            })
                        }

                    </div>

                    {/* === Tabs content group === */}
                    <div className="tabs-content-group">
                        {/* === Tabs Content loop === */
                            tabsData.map((content, contentNumber) => {
                                return(
                                    <div className={ tabIndex === contentNumber ? "tabs-single-content active" : "tabs-single-content"} key={`CONTENT${contentNumber}`}>
                                        <div className="tabs-single-content-left">
                                            <h4 className="title">{content.contentTitle}</h4>
                                            {/* === P segment loop === */
                                                content.contentDescriptions.map((description, di) => {
                                                    return(
                                                        <p key={`DES${di}`} className="description">{description}</p>
                                                    )
                                                })
                                            }
                                            <ul className="si-feature">
                                                {/* === List Loop ===  */
                                                    content.featureList.map((feature, fi) => {
                                                        return(
                                                            <li className="si-item" key={`FL${fi}`}>
                                                                <span className="icon"><FontAwesomeIcon icon={faCheck} /></span>
                                                                <span className="text">{feature}</span>
                                                            </li>
                                                        )
                                                    })
                                                }
                                                
                                            </ul>
                                            <div className="button-group">
                                                <a href={content.andoBtnURL}><FontAwesomeIcon icon={faAndroid} /> Play Store</a>
                                                <a href={content.appelBtnURL} className="app-store"><FontAwesomeIcon icon={faApple} /> App Store</a>
                                            </div>
                                        </div>
                                        <div className="tabs-single-content-right">
                                            <img src={content.phoneIMGPath} alt="event" />
                                        </div>
                                    </div>
                                )
                            })
                        }
                        
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BusinessFeatureTabs
